const DEVICE_ID_STORAGE_KEY = "auth:device-id:v1";
const DEVICE_ID_PATTERN = /^[A-Za-z0-9._:-]{1,64}$/;

function isValidDeviceId(value: string): boolean {
  return DEVICE_ID_PATTERN.test(value);
}

function createDeviceId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return `web-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

/** Stable browser identity for server-managed device slots (survives logout). */
export function getOrCreateWebDeviceId(): string {
  if (typeof localStorage === "undefined") {
    return createDeviceId();
  }

  try {
    const stored = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (stored && isValidDeviceId(stored)) {
      return stored;
    }

    const deviceId = createDeviceId();
    localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
    return deviceId;
  } catch {
    return createDeviceId();
  }
}
